function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScMusicUpload = function SvgScMusicUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      width: 24,
      height: 24
    },
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M19 15V21M19 15C19.2559 15 19.5118 15.0976 19.7071 15.2929L22.4142 18M19 15C18.7441 15 18.4882 15.0976 18.2929 15.2929L15.5858 18M14 23H24",
    stroke: "var(--on-surface)",
    style: {
      stroke: "var(--on-surface)",
      strokeOpacity: 1
    },
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M6.25 12.375V2.77999C6.25 2.26624 6.63929 1.83607 7.1505 1.78495L13.9005 1.10995C14.4892 1.05108 15 1.51337 15 2.10499V10.625M6.25 12.375C6.25 13.8248 5.07475 15 3.625 15C2.17525 15 1 13.8247 1 12.375C1 10.9253 2.17525 9.75 3.625 9.75C5.07475 9.75 6.25 10.9253 6.25 12.375ZM15 10.625C15 12.0747 13.8247 13.25 12.375 13.25C10.9253 13.25 9.75 12.0747 9.75 10.625C9.75 9.17525 10.9253 7.99999 12.375 7.99999C13.8247 7.99999 15 9.17525 15 10.625Z",
    stroke: "var(--on-surface)",
    style: {
      stroke: "var(--on-surface)",
      strokeOpacity: 1
    },
    strokeWidth: 2
  }));
};
export default SvgScMusicUpload;